import { render, staticRenderFns } from "./EditModel2d.vue?vue&type=template&id=4079ca8b&scoped=true"
import script from "./EditModel2d.ts?vue&type=script&lang=ts&external"
export * from "./EditModel2d.ts?vue&type=script&lang=ts&external"
import style0 from "./EditModel2d.vue?vue&type=style&index=0&id=4079ca8b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4079ca8b",
  null
  
)

export default component.exports